<div class="collapsibleTitle pageTitle">
  <div class="collapseButtonContainer pb-0">
    <button
      type="button"
      *ngIf="config.opened"
      class="submitSearchButton"
      (click)="config.opened = !config.opened"
    >
      <em class="fas fa-angle-up"></em>
    </button>
    <button
      type="button"
      *ngIf="!config.opened"
      class="submitSearchButton"
      (click)="config.opened = !config.opened"
    >
      <em class="fas fa-angle-down"></em>
    </button>
    <div class="pageTitle collapsibleTitle">
      <div class="title halfTitle">
        {{ config.title }} ({{
          lists?.totalElementsList + lists?.totalElementsListHistory
        }})
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="config.opened"
  id="mantenimientoContainer"
  class="backgroundSand container fullWidthContainer listPage withoutFilters"
>
  <div class="pageTitle collapsibleTitle">
    <div class="collapseButtonContainer">
      <h5>En trámite</h5>
    </div>
  </div>
  <app-table
    *ngIf="lists.listLoaded"
    [tableList]="config.tableContasts"
    [elementList]="lists.list"
    [routing]="config.routingTableEnTramite"
    [numPages]="lists.numPagesList"
    [numElements]="lists.numElementsList"
    [totalElements]="lists.totalElementsList"
    [filterParams]="filters.filtersTableJSON"
    [options]="config.optionsTable"
    (valueFilterTable)="filterTable($event)"
  ></app-table>
  <div class="pageTitle collapsibleTitle">
    <div class="collapseButtonContainer">
      <h5>Histórico</h5>
    </div>
  </div>
  <app-table
    *ngIf="lists.listHistoryLoaded"
    [tableList]="config.tableContasts"
    [elementList]="lists.listHistory"
    [routing]="config.routingTableHistory"
    [numPages]="lists.numPagesListHistory"
    [numElements]="lists.numElementsListHistory"
    [totalElements]="lists.totalElementsListHistory"
    [filterParams]="filters.filtersTableHistoryJSON"
    [options]="config.optionsTable"
    (valueFilterTable)="filterTableHistory($event)"
  ></app-table>
</div>
